if (!customElements.get('quick-variant-selector')) {
  class QuickVariantSelector extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.hiddenInput = this.querySelector('input[name="id"]');
      this.addBtn = this.querySelector('[data-cross-sell-add]');

      if (!this.addBtn) return;

      if (this.select) {
        this.select.addEventListener('change', () => {
          this.addBtn.disabled = !this.select.value;
        });
      }

      this.addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }

    async addToCart() {
      const variantId = this.select
        ? this.select.value
        : this.hiddenInput
          ? this.hiddenInput.value
          : null;

      if (!variantId) return;

      this.addBtn.classList.add('is-loading');
      this.addBtn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        });

        if (!res.ok) throw new Error('Add to cart failed');

        document.dispatchEvent(new CustomEvent('updateCart'));

        if (typeof MinimogEvents !== 'undefined' && MinimogEvents.emit) {
          MinimogEvents.emit('cart:update');
        }
      } catch (err) {
        console.error('Cross-sell add to cart error:', err);
      } finally {
        this.addBtn.classList.remove('is-loading');
        this.addBtn.disabled = false;
      }
    }
  }

  customElements.define('quick-variant-selector', QuickVariantSelector);
}
